import React from "react";
import { useTranslation } from "react-i18next";
import { isCheckboxDisabled } from './utils/studentModaldisableCheckBox';

interface StudentListModalHeaderRowProps {
  selectAll: boolean;
  toggleAllStudents: () => void;
  isCurrentPeriod: boolean;
  isCurrentOutOfDistrictPeriod?: boolean;
  previousDistrictWindow: boolean;
  districtScreeningSetup?: boolean;
  selectedWindow?: {
    startDate: string | null;
    endDate: string | null;
    value: number | null;
    screeningWindowType: string | null;
    assignmentId: string | null;
  };
}

export const StudentListModalHeaderRow: React.FC<StudentListModalHeaderRowProps> = ({
  selectAll,
  toggleAllStudents,
  isCurrentPeriod,
  isCurrentOutOfDistrictPeriod,
  previousDistrictWindow,
  districtScreeningSetup,
  selectedWindow,
}) => {
  const { t } = useTranslation("dashboard");

  const headerCheckboxDisabled = isCheckboxDisabled({
    districtScreeningSetup,
    selectedWindow,
    isCurrentPeriod,
    isCurrentOutOfDistrictPeriod: !!isCurrentOutOfDistrictPeriod,
    previousDistrictWindow
  });

  return (
    <div className="student-list-header">
      <div className="student-list-row">
        <div className={`checkbox-column${headerCheckboxDisabled ? "-disabled" : ""}`}>
          <input
            type="checkbox"
            id="select-all"
            checked={selectAll}
            onChange={toggleAllStudents}
            data-testid="select-all-checkbox"
            disabled={headerCheckboxDisabled}
          />
        </div>
        <div
          className="header-name-column"
          data-testid="student-list-header-name-column"
        >
          Student Name
        </div>
        <div
          className="header-status-column"
          data-testid="student-list-header-status-column"
        >
          Assessment Status
        </div>
      </div>
    </div>
  );
};